"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var viewerStyle = {
  "::selection": {
    "background-color": "#d4e9ff"
  },
  "img": {
    "-webkit-touch-callout": "none",
    "-webkit-user-select": "none",
    "-khtml-user-select": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none"
  }
};
var _default = viewerStyle;
exports.default = _default;